// ======== project-imports ========
import { NavItemType } from '@/types/bs-types/menu';
import { admins } from './admins';
import {
  applications,
  chartsMap,
  loadingMenu,
  formsTables,
  pages,
  samplePage,
  flowFormPage,
  support,
  widget,
  toComponent
} from './examples';
import { paymentReseachs, researchs, researchsManager, UserReseachs } from './users';
import menuItems from '../base-component/menu-items/components';

// menuComponentItems
// ==============================|| ADMIN MENU ITEMS ||============================== //
// ==========|| admin menu group ||===========
const menuAdminItems: { items: NavItemType[] } = {
  items: [admins]
};

const menuComponentItems: { items: NavItemType[] } = {
  items: menuItems
};

// ==============================|| USER MENU ITEMS ||============================== //
// ==========|| all user menu group ||===========
// for automatic generate breadcrumb title
const menuUserItems: { items: NavItemType[] } = {
  items: [UserReseachs]
};

// ==========|| payment menu group ||===========
const menuPaymentUserItems: { items: NavItemType[] } = {
  items: [paymentReseachs]
};

// ==========|| research menu group ||===========
const menuResearchUserItems: { items: NavItemType[] } = {
  items: [researchs]
};

const menuResearchManagerItems: { items: NavItemType[] } = {
  items: [researchsManager]
};

// ==========|| example menu group ||===========
const menuExampleItems: { items: NavItemType[] } = {
  items: [toComponent, widget, applications, formsTables, chartsMap, samplePage, flowFormPage, pages, support, loadingMenu]
};

const showComponentMenuExampleItems: { items: NavItemType[] } = {
  items: [formsTables]
};

export {
  menuAdminItems,
  menuUserItems,
  menuPaymentUserItems,
  menuResearchUserItems,
  menuResearchManagerItems,
  menuExampleItems,
  menuComponentItems,
  showComponentMenuExampleItems
};
